// ABOUTME: Floating XP gain indicators that show and auto-dismiss
// ABOUTME: Non-blocking overlay for immediate feedback on XP gains

import { useEffect } from 'react'

interface XPGain {
  id: string
  amount: number
}

interface XPGainIndicatorProps {
  gains: XPGain[]
  onGainComplete: (id: string) => void
}

export function XPGainIndicator({ gains, onGainComplete }: XPGainIndicatorProps) {
  return (
    <div className="fixed top-20 right-4 z-40 pointer-events-none">
      {gains.map((gain, index) => (
        <XPGainItem
          key={gain.id}
          gain={gain}
          index={index}
          onComplete={() => onGainComplete(gain.id)}
        />
      ))}
    </div>
  )
}

interface XPGainItemProps {
  gain: XPGain
  index: number
  onComplete: () => void
}

function XPGainItem({ gain, index, onComplete }: XPGainItemProps) {
  useEffect(() => {
    const timer = setTimeout(onComplete, 800)
    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <div className="xp-gain mb-2" style={{ marginTop: index * 8 }}>
      <span className="inline-flex items-center px-3 py-1 rounded-full bg-[var(--color-xp)]/20 text-[var(--color-xp)] font-semibold text-xs uppercase tracking-wider shadow-lg">
        +{gain.amount} XP
      </span>
    </div>
  )
}
